export { default as SpecialCard } from "./SpecialCard";
export * from "./SpecialCard";
